import DOMPurify from 'dompurify';
import { useMemo } from 'react';
import { stripFence } from './utils';

interface Props {
  /** `<svg>...</svg>` 루트. script / on* 핸들러는 sanitize 단계에서 제거. */
  svg: string;
}

const SVG_WRAPPER_HEAD = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 600">';
const SVG_WRAPPER_TAIL = '</svg>';

/**
 * LLM 생성 SVG 를 DOMPurify 로 sanitize 후 inline 렌더.
 * 기본 svg 프로파일이 `<script>`, `on*` 이벤트 핸들러, `<foreignObject>` 안의 HTML 을 모두 제거.
 * LLM 이 `<svg>` 루트 없이 path 들만 보내거나 markdown fence 로 감싼 경우도 렌더되도록 정규화.
 */
export function SvgArtifact({ svg }: Props) {
  const safe = useMemo(() => {
    const stripped = stripFence(svg, 'svg').trim();
    const body = stripped.toLowerCase().startsWith('<svg')
      ? stripped
      : `${SVG_WRAPPER_HEAD}${stripped}${SVG_WRAPPER_TAIL}`;
    return DOMPurify.sanitize(body, {
      USE_PROFILES: { svg: true, svgFilters: true },
    });
  }, [svg]);
  return (
    <div
      className="flex h-full w-full items-center justify-center overflow-auto bg-white p-4 [&>svg]:max-h-full [&>svg]:max-w-full"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: DOMPurify 로 sanitize 된 SVG.
      dangerouslySetInnerHTML={{ __html: safe }}
    />
  );
}
